/*global $, document, window, setTimeout, alert, FG, confirm, location, FGT_CONFIG, console, navigator*/
(function () {
    'use strict';
    FG.Modals = {
        PASSWORD_MIN_LENGTH : 7,
        PASSWORD_PATTERNS : {
            lowercase: new RegExp('[a-z]'),
            uppercase: new RegExp('[A-Z]'),
            number: new RegExp('[0-9]')
        },

        init: function () {},

        initCarousel: function (column) {
            var itemQuantity = $('.item').length,
                multipleScroll = null;

            //if on screen smaller than 622px, only scroll one item at a time
            if (typeof window.matchMedia != 'undefined') {
                multipleScroll = window.matchMedia(
                    'all and (min-width: 622px)'
                ).matches;
            } else {
                multipleScroll = false;
            }

            //if # of upsell items is larger than carousel column #, show carousel navigation
            if (
                itemQuantity > column ||
                (!multipleScroll && itemQuantity > 1)
            ) {
                $('.carousel-control').removeClass('hide');
            }

            $('.upsell').find('.item :first').addClass('active');
            $('#upsellCarousel').carousel({ interval: false, wrap: false });

            $('#upsellCarousel').on('slid.bs.carousel', '', function () {
                var $this = $(this);

                $this.children('.carousel-control').show();

                if ($('.carousel-inner .item:first').hasClass('active')) {
                    $this.children('.left.carousel-control').hide();
                } else if ($('.carousel-inner .item:last').hasClass('active')) {
                    $this.children('.right.carousel-control').hide();
                }
            });

            if (multipleScroll) {
                $('#upsellCarousel').addClass('multiscroll');
                $('.carousel .item').each(function (index) {
                    var current = $(this);
                    var next = current.next();

                    for (var i = 1; i < column; i++) {
                        if (next.length) {
                            next.children(':first-child')
                                .clone()
                                .appendTo(current);
                            next = next.next();
                        } else if (index > 0) {
                            current.remove();
                        }
                    }
                });
            }
        },

        resetErrors: function (form) {
            form.find('.error').removeClass('error');
            form.find('.controls-row.errors span').addClass('hidden');
            form.find('.invalid').removeClass('invalid');
            form.find('.controls-row.invalid span').addClass('hidden');
            form.find('.error-msg').addClass('hide');
        },

        initValidateForm: function (id) {
            var self = this;
            var Form = $('#' + id);
            self.resetErrors(Form);
            Form.find('.required').each(function () {
                var id = $(this).attr('id');
                var $this = $(this);
                $(this).blur(function () {
                    if (!$this.val()) {
                        $this.addClass('invalid');
                        Form.find('label[for="' + id + '"]').addClass(
                            'invalid'
                        );
                        $this.parent().addClass('invalid');

                        $this.attr('aria-describedby', id + '-error-msg');
                        // Hide all error messages for the input to only show the required message
                        $('[id^=' + id + '-error-msg]').addClass('hide');
                        $('#' + id + '-error-msg').addClass('invalid').removeClass('hide');
                    } else {
                        $this.removeClass('invalid');
                        Form.find('label[for="' + id + '"]').removeClass(
                            'invalid'
                        );
                        $this.parent().removeClass('invalid');
                        $('#' + id + '-error-msg').removeClass('invalid').addClass('hide');
                        $this.attr('aria-describedby', '');
                    }
                });
            });
        },

        passwordCheck: function (str) {
            return str.length > FG.Modals.PASSWORD_MIN_LENGTH &&
                FG.Modals.PASSWORD_PATTERNS.lowercase.test(str) &&
                FG.Modals.PASSWORD_PATTERNS.uppercase.test(str) &&
                FG.Modals.PASSWORD_PATTERNS.number.test(str);
        },

        initPasswordCheck: function (form_id) {
            var $form = $('#' + form_id);
            var $passwordInput = $form.find('input[name="new_password"]');
            var $ruleLength = $form.find(".auth-password-rules ul li.rule-length");
            var $ruleType = $form.find(".auth-password-rules ul li.rule-type");

            var hasLowercase = FG.Modals.PASSWORD_PATTERNS.lowercase;
            var hasUppercase = FG.Modals.PASSWORD_PATTERNS.uppercase;
            var hasNumber = FG.Modals.PASSWORD_PATTERNS.number;

            function toggleRule($element, condition) {
                $element.toggleClass('highlight', condition);
                if (condition) {
                    $element.find('.sr-only').text('(completed)');
                } else {
                    $element.find('.sr-only').text('');
                }
            }

            $passwordInput.keyup(function () {
                var $this = $(this);
                var val = $this.val();
                var hasMinimumLength = val.length > FG.Modals.PASSWORD_MIN_LENGTH;

                $this.closest('.f-input-group').find('.error-msg').addClass('hide');
                $this.closest('.f-input-group').removeClass('invalid');
                $this.removeClass('invalid');

                toggleRule($form.find('.map-one-lower'), hasLowercase.test(val));
                toggleRule($form.find('.map-one-upper'), hasUppercase.test(val));
                toggleRule($form.find('.map-one-number'), hasNumber.test(val));
                toggleRule($form.find('.map-len-eight'), hasMinimumLength);

                $ruleLength.toggleClass('valid', hasMinimumLength)
                $ruleType.toggleClass('valid', hasLowercase.test(val) && hasUppercase.test(val) && hasNumber.test(val));
            });
        },

        initMyAccount: function () {
            var state_select = $('#my_select_state'),
                user_state = $('#my_state_other').val();

            if (user_state) {
                //set select menu to reflect user current state
                state_select
                    .find('option[value="' + user_state + '"]')
                    .prop('selected', true);
            }
        },
    };
})();
